import DataLoader from 'dataloader';

export function createLoader<K, V>(
  loadFn: (key: K) => Promise<V>,
  opts: DataLoader.Options<K, V> = {},
) {
  return new DataLoader<K, V>(
    ([key]) =>
      loadFn(key)
        .then(data => [data])
        // always cache errors
        // see https://github.com/graphql/dataloader#caching-errors
        .catch(error => [error]),
    { ...opts, batch: false },
  );
}

export function createBatchLoader<K, V>(
  batchLoadFn: DataLoader.BatchLoadFn<K, V>,
  opts: DataLoader.Options<K, V> = {},
) {
  return new DataLoader<K, V>(
    // always cache errors
    // see https://github.com/graphql/dataloader#caching-errors
    keys => batchLoadFn(keys).catch(error => keys.map(() => error)),
    opts,
  );
}
